import React from 'react';
import ContactMenu from "./ContactMenu.js";
import "../styles/contact.css";

const Contact = () => {
  return (
    <>
      <ContactMenu />
    </>
  );
};

export default Contact;